<template>
    <div>
        <div class="register">
            <h2>{{ registerType == '0' ? '学员注册':'报名机构注册' }}</h2>
            <!-- 学员注册 -->
            <el-form  v-if="registerType == '0'" :model="studentForm" :rules="studentRules" ref="studentForm" label-position="left" label-width='100px'>
                <el-form-item label="姓名" prop="studentName">
                    <el-input v-model.trim="studentForm.studentName" placeholder="请输入您的姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="studentIdno">
                    <el-input v-model.trim="studentForm.studentIdno" placeholder="请输入您的身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="studentPhone">
                    <el-input v-model.trim="studentForm.studentPhone" placeholder="请输入您的手机号码"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="studentYzm" class="register-captan clearfix">
                    <el-input v-model.trim="studentForm.studentYzm" placeholder="验证码"></el-input>
                    <img class="fl" @click="refreshCode()" :src="yzmurl" />
                    <a class="fl" href="javascript:void(0)" @click="refreshCode()">换一张</a>
                </el-form-item>
                <el-button type="primary" class="submit" @click="studentSubmit()">提交</el-button>
            </el-form>

             <!-- 机构注册 -->
            <el-form v-if="registerType == '1'" :model="orgRegisterForm" :rules="orgRules" ref="orgRegisterForm" label-position="left" label-width='120px'>
                <el-form-item label="机构名称" prop="organizationName">
                    <el-input v-model.trim="orgRegisterForm.organizationName" placeholder="机构名称"></el-input>
                </el-form-item>
                <el-form-item label="统一机构代码" prop="unifiedSocialCreditCode">
                    <el-input v-model.trim="orgRegisterForm.unifiedSocialCreditCode" placeholder="统一机构代码"></el-input>
                </el-form-item>
                <el-form-item label="机构地址" prop="organizationAddress">
                    <el-input v-model.trim="orgRegisterForm.organizationAddress" placeholder="机构地址"></el-input>
                </el-form-item>
                <el-form-item label="营业执照" prop="businessLicenseUrl">
                    <div class="gzh-img">
                        <img v-if="orgRegisterForm.businessLicenseUrl" id="imagew" class="zs-img" :src="orgRegisterForm.businessLicenseUrl" width="100px" height="100px" />
                        <img v-else class="zs-mrimg" src="../../static/images/addimg.png" width="100px" height="100px"  />
                        <input
                            id="doc"
                            name="photo"
                            type="file"
                            class="upheadimg-hover"
                            accept="image/gif, image/png, image/jpeg, image/jpg, image/JPG, image/JPEG, image/PNG, image/GIF"
                            @change="prview($event)"
                        />
                    </div>
                </el-form-item>
                <el-form-item label="管理员姓名" prop="realName">
                    <el-input v-model.trim="orgRegisterForm.realName" placeholder="管理员姓名"></el-input>
                </el-form-item>
                <el-form-item label="管理员电话" prop="mobile">
                    <el-input v-model.trim="orgRegisterForm.mobile" placeholder="管理员电话"></el-input>
                </el-form-item>
                <el-form-item label="登录用户名" prop="username">
                    <el-input v-model.trim="orgRegisterForm.username" placeholder="登录用户名"></el-input>
                </el-form-item>
                <el-form-item label="设置密码" prop="password">
                    <el-input type="password" v-model.trim="orgRegisterForm.password" placeholder="请输入由8-16位字母和数字组合的密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input type="password" v-model.trim="orgRegisterForm.confirmPassword" placeholder="请再次输入登录密码"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="captcha" class="register-captan clearfix">
                    <el-input v-model.trim="orgRegisterForm.captcha" placeholder="验证码"></el-input>
                    <img class="fl" @click="refreshCode()" :src="yzmurl" />
                    <a class="fl" href="javascript:void(0)" @click="refreshCode()">换一张</a>
                </el-form-item>

                <el-button type="primary" class="submit" @click="orgSubmit()">提交</el-button>

            </el-form>





        </div>
    </div>
</template>
<style scoped>
.register{
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    margin-bottom: 30px;
}
.register h2{
    font-size: 24px;
    line-height: 40px;
    color: #da5252;
    text-align: center;
    font-weight: bold;
    margin-bottom: 25px;
}
/* 学员注册 */
.register /deep/ .el-form-item__label{
    text-align: right;
}
.register .register-captan /deep/ .el-form-item__label{
    float: left;
}
.register .register-captan /deep/ .el-input{
    display: block;
    float: left;
    width: 120px;
    margin-right: 12px;
	
}
.register .register-captan img{
    height: 36px;
    margin: 2px 12px 2px 2px;
    margin-right: 12px;
    cursor: pointer;
}
.register .register-captan a{
    font-size: 14px;
	color: #333333;
	line-height: 40px;
    text-decoration: none;
}
.submit{
    display: block;
    width: 120px;
    margin: 0 auto;
    margin-top: 60px;
}
/* 图片上传 */
.gzh-img{
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: relative;
    border: 1px solid #e5e5e5;
}
.gzh-img .zs-mrimg,
.gzh-img .zs-img{
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
}
.gzh-img .zs-img{
    z-index: 3;
}
.gzh-img .upheadimg-hover{
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    text-decoration: none;
    padding: 0;
    margin: 0;
    font-size: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 4;
    cursor: pointer;
    opacity: 0;
}

</style>
<script>
export default {
	data() {
        //身份证验证
        var checkIdentitytionId = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("身份证号不能为空"));
            }
            if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                callback(new Error("你输入的身份证长度或格式错误"));
            }
            //身份证城市
            var aCity = {
                11: "北京",
                12: "天津",
                13: "河北",
                14: "山西",
                15: "内蒙古",
                21: "辽宁",
                22: "吉林",
                23: "黑龙江",
                31: "上海",
                32: "江苏",
                33: "浙江",
                34: "安徽",
                35: "福建",
                36: "江西",
                37: "山东",
                41: "河南",
                42: "湖北",
                43: "湖南",
                44: "广东",
                45: "广西",
                46: "海南",
                50: "重庆",
                51: "四川",
                52: "贵州",
                53: "云南",
                54: "西藏",
                61: "陕西",
                62: "甘肃",
                63: "青海",
                64: "宁夏",
                65: "新疆",
                71: "台湾",
                81: "香港",
                82: "澳门",
                91: "国外"
            };
            if (!aCity[parseInt(value.substr(0, 2))]) {
                callback(new Error("你的身份证地区非法"));
            }
            // 出生日期验证
            var sBirthday = (
                value.substr(6, 4) +
                "-" +
                Number(value.substr(10, 2)) +
                "-" +
                Number(value.substr(12, 2))
                ).replace(/-/g, "/"),
                d = new Date(sBirthday);
            if (
                sBirthday !=
                d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
            ) {
                callback(new Error("身份证上的出生日期非法"));
            }

            // 身份证号码校验
            var sum = 0,
                weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                codes = "10X98765432";
            for (var i = 0; i < value.length - 1; i++) {
                sum += value[i] * weights[i];
            }
            var last = codes[sum % 11]; //计算出来的最后一位身份证号码
            if (value[value.length - 1] != last) {
                callback(new Error("你输入的身份证号非法"));
            }
            callback();
        };
		/*校验手机号*/
		var checkMobile = (rule, value, callback) => {
            if (value==''){
				return callback(new Error("请输入手机号码"));
			}
			if (!this.$util.isPhoneNumber(value)) {
				return callback(new Error("手机号码不正确"));
			} else {
				callback();
			}
		};
        //校验密码的规范性
		var isLetterNumber = (rule, value, callback) => {
            if (value === "") {
				callback(new Error("请输入密码"));
			} else if (!this.$util.isPassword(value)) {
				return callback(new Error("密码为8-16位字母和数字组合"));
			}
			callback();
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请再次输入密码"));
			} else if (value !== this.orgRegisterForm.password) {
				callback(new Error("两次输入密码不一致!"));
			} else {
				callback();
			}
		};
        //校验统一社会信用代码
        var validlegalbizLicNum = (rule, value, callback) =>{
            if(value == ""){
                callback(new Error("请输入统一社会信用代码！"));
            }else {
                let Ancode;//统一社会信用代码的每一个值
                let Ancodevalue;//统一社会信用代码每一个值的奴重
                let total = 0;
                let weightedfactors = [1,3,9,27,19,26,16,17,20,29,25,13,8,24,10,30,28];//加权因子
                //不用I、O、S. V、Z
                let str = "0123456789ABCDEFGHJKLMNPQRTUWXY";
                for (let i = 0; i < value.length - 1; i++){
                    Ancode = value.substring(i, i + 1);
                    Ancodevalue = str.indexOf(Ancode);
                    total = total + Ancodevalue * weightedfactors[i];//权重与加权因子相乘之和
                }
                let logiccheckcode = 31 - total % 31;
                if (logiccheckcode == 31){
                    logiccheckcode = 0;
                }
                let Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
                let Array_str = Str.split(",");
                logiccheckcode = Array_str[logiccheckcode];
                let checkcode = value.substring(17,18);
                if (logiccheckcode != checkcode){
                    return callback(new Error("请输入正确的统一社会信用代码! "));;
                }
                return callback();
            }

        };
		return {
			registerType: "",//注册类型，0为学员，1位机构
            yzmurl:'',//图片二维码地址
            studentForm:{
                studentName:'',
                studentIdno:'',
                studentPhone:'',
                studentYzm:'',
            },
            studentRules:{
                studentName: [{required: true, message: "请输入真实姓名", trigger: "blur",}],
				studentPhone:  [{required: true, validator: checkMobile, trigger: "blur"}],
				studentIdno:  [{required: true, validator: checkIdentitytionId, trigger: "blur"}],
                studentYzm: [{required: true, message: "验证码不能为空", trigger: "blur",}],
            },


            orgRegisterForm: {
                organizationName: "",//机构名称
                unifiedSocialCreditCode: "",//统一机构代码
                organizationAddress: "",//机构地址
                businessLicenseUrl:"",//营业执照图片地址
                realName:"",//管理员姓名
                mobile:"",//管理员电话
                username:'',//登录用户名
                password:'',//登录密码
                confirmPassword:'',//再次确认的密码
                captcha:'',//图片验证码
            },
			orgRules: {
                organizationName: [{required: true, message: "请输入机构名称", trigger: "blur",}],
                unifiedSocialCreditCode: [{required: true, validator: validlegalbizLicNum, trigger: "blur",}],
                organizationAddress: [{required: true, message: "请输入机构地址", trigger: "blur",}],
                businessLicenseUrl: [{required: true, message: "请上传营业执照", trigger: "blur",}],
                realName: [{required: true, message: "请输入管理员姓名", trigger: "blur",}],
                mobile:  [{required: true, validator: checkMobile, trigger: "blur"}],
                username: [{required: true, message: "请输入用户名", trigger: "blur",}],
                password: [{required: true, validator: isLetterNumber, trigger: "blur"}],
                confirmPassword: [{required: true, validator: validatePass2, trigger: "blur"}],
                captcha: [{required: true, message: "请输入验证码", trigger: "blur",}],
			},

		};
	},
    created() {
        this.registerType = this.$route.query.signType;//获取注册的类型
        //初始化二维码地址
        this.refreshCode();
	}, 
	methods: {
        //刷新图片验证码
        refreshCode(){
			var timenow = new Date().getTime();
			this.yzmurl = process.env.API_URL + "servlet/Image.Servlet?d=" + timenow;
		},
        //学员提交注册
        studentSubmit(){
            this.$refs.studentForm.validate((valid) => {
                if(valid){
                    let params = {};
                    params.studentName = this.studentForm.studentName;
                    params.idcard = this.studentForm.studentIdno;
                    params.mobile = this.studentForm.studentPhone;
                    params.captcha = this.studentForm.studentYzm;
                    this.$api.post("/api/studentInfo/registerStudentInfo", params, (res) => {
                        if (res.status == 0) {
                            this.$alert('注册成功，跳转首页去登录！', '提示', {confirmButtonText: '确定', callback: action => {
                                    this.rightIndex();//注册成功返回首页
                                }
                            });
                        }else{
                            this.$message.error(res.message)
                        }
                        
                    });
                }
            })
        },
        //报名机构提交注册
        orgSubmit(){
            this.$refs.orgRegisterForm.validate((valid) => {
                if(valid){
                    let params = {};
                    params.organizationName = this.orgRegisterForm.organizationName;
                    params.unifiedSocialCreditCode = this.orgRegisterForm.unifiedSocialCreditCode;
                    params.organizationAddress = this.orgRegisterForm.organizationAddress;
                    params.businessLicenseUrl = this.orgRegisterForm.businessLicenseUrl;
                    params.realName = this.orgRegisterForm.realName;
                    params.mobile = this.orgRegisterForm.mobile;
                    params.username = this.orgRegisterForm.username;
                    params.password = this.orgRegisterForm.confirmPassword;
                    params.captcha = this.orgRegisterForm.captcha;
                    this.$api.post("/api/adminInfo/registerOrgAdminInfo", params, (res) => {
                        if (res.status == 0) {
                            this.$alert('注册成功，跳转首页去登录！', '提示', {confirmButtonText: '确定', callback: action => {
                                    this.rightIndex();//注册成功返回首页
                                }
                            });
                        }else{
                            this.$message.error(res.message)
                        }
                        
                    });

               }
            })
        },
        //照片上传并预览
        prview(event) {
			let file = event.target.files[0];
			if (file.size > 1024 * 1024 * 20) {
				this.$message.error("图片最大支持20M");
				var file1 = document.getElementById("doc");
				file1.value = "";
				return;
			}
            //上传图片至服务器
            let formData = new FormData();
            formData.append("uploadFile", file);
            this.$api.formpost("/api/studentInfo/fileUpload", formData, (res) => {
                if (res.status == 0) {//上传成功
                    this.$message.success('上传成功')
                    this.orgRegisterForm.businessLicenseUrl = res.data;
                }else{
                    this.$message.error(res.message);
                }


            });
		},
		//跳到登录页
		rightIndex() {
			this.$router.push({path: "/"});
            // location.reload();
		},

        
	},
	 
};
</script>



// WEBPACK FOOTER //
// src/views/register.vue